<template>
  <img :alt="alt" :src="computedSrc">
</template>

<script>
export default {
  name: "Imgix",
  props: ["alt", "src", "w", "h"],
  computed: {
    computedSrc: function() {
      //if (this.$store.state.ready) return this.src.replace("ctbutterfield-media.s3.eu-west-2.amazonaws.com", "ctbutterfield.imgix.net") + "?auto=format&w=" + this.w + "&h=" + this.h
      //else return "https://ctbutterfield.imgix.net/temp.gif" + "?auto=format&w=" + this.w + "&h=" + this.h
      //return this.src.replace("ctbutterfield-media.s3.eu-west-2.amazonaws.com", "ctbutterfield.imgix.net") + "?auto=format&w=" + this.w + "&h=" + this.h
      return this.src
    }
  }
}
</script>
